export default {
  form: {
    display_name: {
      label: 'Restaurantnaam',
      placeholder: 'Voer restaurantnaam in',
      help: 'Gebruikt op uw contract en facturen',
    },
    store_address: {
      label: 'Winkeladres',
      placeholder: 'Zoek naar uw adres',
      help: 'Dit is het adres dat uw klanten zien',
    },
    address: {
      label: 'Adres',
      placeholder: 'Straat + huisnummer',
    },
    zip_code: {
      label: 'Postcode',
      placeholder: 'Postcode',
    },
    city: {
      label: 'Plaats',
      placeholder: 'Plaats',
    },
    state: {
      label: 'Provincie',
      placeholder: 'Selecteer provincie',
    },
    country: {
      label: 'Land',
      help: 'Om uw restaurant naar een ander land te verplaatsen, neem contact op met support',
    },
  },
  staff_notice:
    'Winkelpersoneel kan de naam en het adres van het restaurant niet bevestigen. Vraag uw onboarding manager om deze gegevens te controleren.',
  toasts: {
    saved: 'Winkelgegevens opgeslagen',
    error: 'Uw winkelgegevens konden niet worden opgeslagen',
  },
  buttons: {
    next: 'Volgende',
  },
};
